<div *ngIf="isNewClicked">
    <div class="row-new add-first">
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
            <span class="form-inline-new">
                <p class="lob-headers">Segment
                    <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
                </p>
            </span>
            <mat-form-field *ngIf="isNewClicked" [floatLabel]="'never'" class="add-dropdown lob-border">
                <input class="lob-new-dropdown edit text-notavailable-option option-size" />
                <mat-select (selectionChange)="getNewMappedLob($event)" [(ngModel)]="AddLobDataUpdated.master_segment"
                    placeholder="Select Segment">
                    <mat-option class="dropDownList"  *ngFor="let segment of segmentData" [value]="segment">
                        <ng-container>
                            {{segment.segment}}
                        </ng-container>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
            <span class="lob-new">
                <p class="lob-headers">LOB
                    <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
                </p>

                <button *ngIf="!newLobClicked" (click)="newLob()" mat-mdc-raised-button class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
                    Create New
                </button>
                <button *ngIf="newLobClicked" (click)="newLob()" mat-mdc-raised-button class="create-new-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
                    Existing LOB
                </button>
            </span>

                <mat-form-field *ngIf="!newLobClicked" [floatLabel]="'never'" class="add-dropdown lob-border">
                    <input class="lob-new-dropdown edit text-notavailable-option option-size" />
                    <mat-select [(ngModel)]="AddLobDataUpdated.cio_lob" (selectionChange)="lobChange($event)"
                        placeholder="Select an LOB">
                        <mat-option class="dropDownList" *ngFor="let lob of lobData" [value]="lob">
                            <ng-container>
                                {{lob.CIOLOB}}
                            </ng-container>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <input *ngIf="newLobClicked" (input)="disableApplyAddLob()" [(ngModel)]="AddLobDataUpdated.lobNameEntered" Placeholder="Enter an LOB Name"
                    class="lob-newLob lob-add-input lob-border">
        </div>
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4">
            <span class="form-inline-new">
                <p class="lob-headers">Sub LOB
                    <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
                </p>
            </span>
            <input (input)="disableApplyAddLob()" [(ngModel)]="AddLobDataUpdated.sub_lob" Placeholder="Enter Sub LOB Name" class="lob-add-input lob-border">
        </div>
    </div>
    <div class="row-new lob-desc">
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 text-area-block">
            <span class="form-inline-new">
                <p class="lob-headers lob-headers-desc">LOB Description</p>
            </span>
            <ng-container>
                <mat-form-field [ngClass]="{'lob-desc-disabled' : !newLobClicked}" appearance="outline" class="lob-add-description">
                    <p class="lob-desc-p"><textarea [disabled]="!newLobClicked" [(ngModel)]="AddLobDataUpdated.LOB_description" class="textarea_text lob-textarea lob-lob-textarea p-1" 
                        cols="100" rows="4" maxlength="500" matInput placeholder=""></textarea></p>
                </mat-form-field>
            </ng-container>
            <p class="lob-text-right">Maximum 500 Characters</p>
        </div>
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 text-area-block">
            <span class="form-inline-new">
                <p class="lob-headers lob-headers-desc">Sub LOB Description</p>
            </span>
            <mat-form-field appearance="outline" class="lob-add-description">
                <p class="lob-desc-p"><textarea [(ngModel)]="AddLobDataUpdated.Sub_LOB_description" class="textarea_text lob-textarea p-1"
                        cols="100" rows="4" maxlength="500" matInput placeholder=""></textarea></p>
            </mat-form-field>
            <p class="lob-text-right">Maximum 500 Characters</p>
        </div>        
    </div>
    <div class="row-new lob-architect-row">
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="lob-headers lob-headers-architects">Chief Architect</p>
            </span>
            <div class="lob-chip-field lob-border">
                <app-user-management role="CA" [existingUser] = "[]" [TABLE_CONFIG]="TABLE_CONFIG" [TABLE_COLUMNS]="TABLE_COLUMNS" [actionType]="'Add'" (getLatestChanges)="addUpdatedValueForChiefArchitect($event)"></app-user-management>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="lob-headers lob-headers-architects">Architect Delegate</p>
            </span>
            <div class="lob-chip-field lob-border">
                <app-user-management role="AD" [existingUser] = "[]" [TABLE_CONFIG]="TABLE_CONFIG" [TABLE_COLUMNS]="TABLE_COLUMNS" [actionType]="'Add'" (getLatestChanges)="addUpdatedValueForArchitectDelegate($event)"></app-user-management>
            </div>
        </div>
    </div>
    <div class="pull-right lob-add-apply-margin">
        <button mat-mdc-raised-button [disabled]="disableAddLob" (click)="onSubmit(false)" class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
            Apply
        </button>
    </div>    
</div>




<div *ngIf="isSubLobEditClicked">
    <div class="row-new lob-edit-first slob-edit-first">
        <div class="col-md-1 col-sm-3 col-lg-1 col-xl-1 col-xs-1">
            <span class="form-inline-new">
                <p class="lob-headers">Segment</p>
            </span>
            <span>
                <p class="edit-defaults">{{ this.EditColumnDataSubLob.MasterSegment }}</p>
            </span>
        </div>
        <div class="col-md-2 col-sm-4 col-lg-2 col-xl-2 col-xs-2 lob-edit-lobName">
            <span class="form-inline-new">
                <p class="lob-headers">LOB</p>
            </span>
            <span title="{{ EditColumnDataSubLob.CIOLOB }}">
                <p class="edit-defaults lob-default-name">{{ this.EditColumnDataSubLob.CIOLOB }}</p>
            </span>
        </div>
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name">
            <span class="form-inline-new">
                <p class="lob-headers">Sub LOB</p>
            </span>
            <input (input)="disableApplyEditSubLob()" [(ngModel)]="EditSubLobFinal.SubLineofBusiness.value" Placeholder="Enter Sub LOB Name" class="lob-add-input lob-border">
        </div>
        <div class="col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5 text-area-block">
            <span class="form-inline-new">
                <p class="lob-headers ">Sub LOB Description</p>
            </span>
            <mat-form-field appearance="outline" class="lob-add-description slob-edit-desc">
                <p class="lob-desc-p"><textarea (input)="disableApplyEditSubLob()" [(ngModel)]="EditSubLobFinal.Sub_LOB_description.value" class="textarea_text lob-textarea p-1"
                        cols="100" rows="4" maxlength="500" matInput placeholder=""></textarea></p>
            </mat-form-field>
            <p class="lob-text-right">Maximum 500 Characters</p>
        </div>
    </div>
    <div class="row-new slob-edit-first">
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="lob-headers">Chief Architect</p>
            </span>
            <div class="lob-chip-field sublob-architects lob-border">
                <app-user-management role="CA" [existingUser] = "chiefArchitectEditSubLob" [TABLE_CONFIG]="TABLE_CONFIG" [TABLE_COLUMNS]="TABLE_COLUMNS" [actionType]="'Edit'" (getLatestChanges)="getUpdatedValueForChiefArchitect($event)"></app-user-management>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
            <span class="form-inline-new">
                <p class="lob-headers">Architect Delegate</p>
            </span>
            <div class="lob-chip-field sublob-architects lob-border">
                <app-user-management role="AD" [existingUser] = "architectDelegateEditSubLob" [TABLE_CONFIG]="TABLE_CONFIG" [TABLE_COLUMNS]="TABLE_COLUMNS" [actionType]="'Edit'" (getLatestChanges)="getUpdatedValueForArchitectDelegate($event)"></app-user-management>
            </div>
        </div>
    </div>
    <div class="pull-right subLob-edit-apply">
        <button mat-mdc-raised-button [disabled]="disableEditSubLob" (click)="onSubmit(true)" class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
            Apply
        </button>
    </div>
</div>

<div *ngIf="EditColumnDataLob">
    <div class="row-new lob-edit-first">
        <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name">
            <span class="form-inline-new">
                <p class="lob-headers">LOB</p>
            </span>
            <input (input)="disableApplyLob()" [(ngModel)]="EditLobFinal.cio_lob.value" Placeholder="Enter LOB Name" class="lob-add-input lob-border">
        </div>
        <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 text-area-block">
            <span class="form-inline-new">
                <p class="lob-headers lob-headers-lob-desc">LOB Description</p>
            </span>
            <ng-container>
                <mat-form-field appearance="outline" class="lob-add-description">
                    <p class="lob-desc-p"><textarea (input)="disableApplyLob()" [(ngModel)]="EditLobFinal.LOB_description.value" class="textarea_text lob-textarea lob-lob-textarea p-1" 
                        cols="100" rows="4" maxlength="500" matInput placeholder=""></textarea></p>
                </mat-form-field>
            </ng-container>
            <p class="lob-text-right">Maximum 500 Characters</p>
        </div>
    </div>
    <div class="pull-right">
        <button mat-mdc-raised-button [disabled]="disableEditLob" (click)="applyEditLob()" class="add-apply lob-edit-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
            Apply
        </button>
    </div>
</div>
